// src/app/services/eliminatorApi.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { IEliminator, IEliminatorParams, UpdatePayload } from '../models';

export const eliminatorApi = createApi({
  reducerPath: 'eliminatorApi',
  baseQuery,
  endpoints: (builder) => ({
    getEliminatorParams: builder.query<{ eliminator: IEliminatorParams }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/eliminators/params/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getEliminator: builder.query<IEliminator, number>({
      query: (id) => `/api/v1.0/ahu/eliminators/${id}`,
      transformResponse: (data: IEliminator) => {
        data.params = data.eliminator_params ? JSON.parse(data.eliminator_params) : {};
        data.frameParams = data.frame_params
          ? JSON.parse(data.frame_params)
          : {};
        return data;
      },
    }),
    getAllEliminatorsCount: builder.query<{ count: number }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/eliminators/all/count/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getEliminatorsCount: builder.query<{ count: number }, string>({
      query: (queryString) =>
        `/api/v1.0/cms/1/v1.0.0/ahu/eliminators/all/count/?${queryString}`,
      extraOptions: {
        cacheData: true,
      },
    }),
    getAllEliminatorsFramesCount: builder.query<{ count: number }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/eliminators/frames/all/count/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getEliminatorsFramesCount: builder.query<{ count: number }, string>({
      query: (queryString) =>
        `/api/v1.0/cms/1/v1.0.0/ahu/eliminators/frames/all/count/?${queryString}`,
      extraOptions: {
        cacheData: true,
      },
    }),
    updateEliminator: builder.mutation<IEliminator, UpdatePayload<IEliminator>>({
      query: ({ id, body, signal }) => ({
        url: `/api/v1.0/ahu/eliminators/${id}`,
        method: 'PATCH',
        body,
        signal,
      }),
      transformResponse: (data: IEliminator) => {
        data.params = data.eliminator_params ? JSON.parse(data.eliminator_params) : {};
        data.frameParams = data.frame_params
          ? JSON.parse(data.frame_params)
          : {};
        return data;
      },
    }),
  }),
});

export const {
  useLazyGetEliminatorQuery,
  useGetEliminatorParamsQuery,
  useLazyGetEliminatorsCountQuery,
  useGetAllEliminatorsCountQuery,
  useGetAllEliminatorsFramesCountQuery,
  useLazyGetEliminatorsFramesCountQuery,
  useUpdateEliminatorMutation,
} = eliminatorApi;
